import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';
import { AppContext, AppType } from '@commenda/utils';
import { useContext } from 'react';

import { useIsAffiliateWorkflowEditor } from '../../context/AffiliateWorkflowEditorContext';

// The admin app, or the affiliate workflow editor by its own context rather
// than by app type, so enterprise customers outside the affiliate area see
// none of the document fields.
export const useIsAgentDocumentConfigurable = (): boolean => {
  const appContext = useContext(AppContext);
  const isAffiliateWorkflowEditor = useIsAffiliateWorkflowEditor();

  return (
    (appContext?.appType === AppType.ADMIN || isAffiliateWorkflowEditor) &&
    isFeatureLaunched(FeatureLaunch.DOCUMENT_ASSEMBLER)
  );
};
